import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import safelyStringifyJSON from '../../utils/safelyStringifyJSON';
import { ACURA_SITE_NAME, HONDA_SITE_NAME } from '../../utils/constants';
import { createObjectFromProps, isEmpty } from '../../utils/object';
import NotImplemented from '../NotImplemented';
import { useAppName } from '../../utils/sitecoreContext';
import { useAppSelector } from '../../core/utils';
import { selectVehicleByTrim, selectBodyTypesForGtm } from '../../core/reducers/vehicles';
import { selectDealer } from '../../core/reducers/dealer';
import ViewTrimHighlightsUI from './ViewTrimHighlights';
import isSSR from '../../utils/isSSR';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
import getSubPagePath from './utils/getSubPagePath';
const ViewTrimHighlights = ({ fields, rendering }) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const appName = useAppName();
    let mappedFields = ((_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) || {};
    mappedFields = useMemo(() => createObjectFromProps(mappedFields), [safelyStringifyJSON(mappedFields)]);
    const { modelKey = '', modelYear = '', trimKey, inventoryStatus } = useSelector(selectCurrentVehicle);
    const { dealerName } = useAppSelector(selectDealer);
    const gtmBodyStyle = useSelector(selectBodyTypesForGtm);
    const trim = useAppSelector(state => selectVehicleByTrim(state, trimKey));
    switch (appName) {
        case ACURA_SITE_NAME:
        case HONDA_SITE_NAME:
            break;
        default:
            return React.createElement(NotImplemented, { name: "View Trim Highlights " });
    }
    const models = (_d = (_c = (_b = mappedFields === null || mappedFields === void 0 ? void 0 : mappedFields.catalog) === null || _b === void 0 ? void 0 : _b.models) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.items;
    const pathName = isSSR() ? '' : window.location.origin;
    const ctaBaseUrl = getSubPagePath(models, modelKey, modelYear, 'trims');
    const ctaLabel = t('Shared.Common.viewTrimHighlightsButton');
    const linkUrl = `${pathName}${ctaBaseUrl}?trim=${trimKey}`;
    const gtmPayload = {
        event: 'dealer_inventory_cta_click',
        interaction_type: 'cta: explore',
        dealer_name: dealerName,
        cta_type: 'explore',
        cta_placement: 'dealer inventory',
        link_text: 'view trim highlights',
        link_url: linkUrl,
        component_type: rendering === null || rendering === void 0 ? void 0 : rendering.componentName,
        model: trim === null || trim === void 0 ? void 0 : trim.modelName,
        trim: trim === null || trim === void 0 ? void 0 : trim.trimName,
        body_style: gtmBodyStyle,
        availability_flag: inventoryStatus,
    };
    if (!mappedFields || isEmpty(mappedFields) || !mappedFields) {
        return null;
    }
    return React.createElement(ViewTrimHighlightsUI, { linkUrl: linkUrl, ctaLabel: ctaLabel, gtmPayload: gtmPayload });
};
export default ViewTrimHighlights;
